module.exports = __webpack_public_path__ + "static/media/advisor-avatar.9157c623.svg";